import { CriteoIntegration } from "./_criteoApi";

export class CriteoCartPage extends CriteoIntegration {
  #selectors = {
    container: "#criteo-owl-carousel",
    carousel: "#criteo-owl",
    productCards: ".cart-products .cart-product-card",
  };

  #generateParams() {
    const productCards = document.querySelectorAll(
      this.#selectors.productCards,
    );

    const cartValues = Array.from(productCards).map((productCard) => ({
      item: productCard.dataset.productSku,
      price: productCard.dataset.productPrice / 100,
      quantity: productCard.dataset.productQty,
    }));

    const params = {
      item: "",
      price: "",
      quantity: "",
    };

    cartValues.forEach((val) =>
      Object.entries(val).forEach(
        ([key, value]) => (params[key] += `${params[key] ? "|" : ""}${value}`),
      ),
    );

    return params;
  }

  async exec() {
    if (!this._isActive) return;
    if (this._isMarketingBlocked()) return;

    const { placements } = await this._baseRequest("viewBasket", {
      ...this.#generateParams(),
    });

    if (!placements.length) {
      document.querySelector(this.#selectors.container).style.display = "none";
      return;
    }

    const device = screen.width <= 750 ? "Mobile" : "Desktop";

    const [
      {
        [`viewBasketApi${device}-Carousel`]: [
          { products, OnViewBeacon, OnLoadBeacon },
        ],
      },
    ] = placements;

    return await this._renderCarousel(products, OnViewBeacon, OnLoadBeacon);
  }
}
